import { IModel, IOwnedViolation, IValidationContext, Named, ValidateInternalObject } from 'shell-models-lib';

export abstract class BaseExtensiveValidationService {
    public abstract ensureA365ObjectState(obj: ValidateInternalObject): Promise<void>;
    public abstract validateRbac(context: IValidationContext, encounteredModels: Map<IModel, Named>): Promise<IOwnedViolation[]>;
}
